import { Auth, API } from 'aws-amplify'

const options = async () => {
  const user = await Auth.currentAuthenticatedUser()
  return {
    headers: {
      Authorization: user.signInUserSession.idToken.jwtToken
    }
  }
}

const post = async (param1, param2, body) => API.post(param1, param2, { ...(await options()), body })
const put = async (param1, param2, body) => API.put(param1, param2, { ...(await options()), body })
const get = async (param1, param2, body) => API.get(param1, param2, { ...(await options()), body })

export default { post, get, put }